import { ComponentBase } from "@abstracts/component-base";
import {
  Component,
  HostListener,
  Injector,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Roles } from "@enums/roles.enum";
import { UserProfile } from "@dto/userProfile";
import { plainToClass } from "class-transformer";
import { UserDto } from "@dto/userDto";
import { UsersService } from "../../../services/entity/users.service";
import { CustomersService } from "@services/entity/customers.service";
import { CustomerDto } from "../../../dto/customerDto";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PricingsService } from "@services/entity/pricings.service";
import { PricingDto } from "@dto/pricingDto";
import { AppConfigurationClient } from "@azure/app-configuration";
import { environment } from "src/environments/environment";
import { ToastService } from "@services/toast/toast.service";
import { BlackboxService } from "@services/entity/blackbox.service";
import { ChargingStationsService } from "@services/entity/charging-stations.service";
import { NgxScannerQrcodeComponent } from "ngx-scanner-qrcode";
import { Observable } from "rxjs";

@Component({
  selector: "app-nav-menu",
  templateUrl: "./nav-menu.component.html",
  styleUrls: ["./nav-menu.component.scss"],
})
export class NavMenuComponent extends ComponentBase implements OnInit {
  public className = "NavMenuComponent";

  public screenWidth: any;
  public screenHeight: any;
  public profilePicture: any;
  public picture: any;

  public isStageTesting: boolean = false;
  public isStageDev: boolean = false;
  public isStageExperimental: boolean = false;
  public isStageLocal: boolean = false;

  public user: UserDto;
  public customers: CustomerDto[];
  public userProfile: UserProfile;
  public currentUser: UserDto = new UserDto();

  public isAllowedInvoices: boolean = false;
  public isProduction: boolean = false;
  public isSitePartner: boolean = false;
  public isVfl: boolean = false;
  public isRuhr: boolean = false;
  public isFunke: boolean = false;
  public isOpen: boolean = false;
  public isStihl: boolean = false;
  public hasMultiple: boolean = false;
  public isUserAuthenticated: boolean;
  public isVisible: boolean = false;
  public isOffScreen: boolean = false;
  public isNavCollapsed: boolean = false;
  public isBlackboxAvailable: boolean = false;
  public pool = "";
  public isScanPending: boolean = false;
  public isScanOpen: boolean = false;
  private qrActionInstance: NgxScannerQrcodeComponent;
  private isQrScannerSubscribed: boolean = false;

  @ViewChild("qrAction", { static: false })
  set qrAction(value: NgxScannerQrcodeComponent) {
    if (!value || value === this.qrActionInstance) {
      this.qrActionInstance = value;
      return;
    }
    this.qrActionInstance = value;
    this.subscribeToQrScanner();
  }

  get qrAction(): NgxScannerQrcodeComponent {
    return this.qrActionInstance;
  }

  public isOperator: boolean = false;
  public isCustomer: boolean = false;
  public isUser: boolean = false;
  public isSupporter: boolean = false;
  public isTechnical: boolean = false;
  public isAccount: boolean = false;
  todayDate: string;
  public whitelabel: string;
  public whitelabelURL: string =
    "https://cubosgeneralstorage.blob.core.windows.net/whitelabel-storage/";
  pool$: string;

  constructor(
    private usersService: UsersService,
    private router: Router,
    private modalService: NgbModal,
    private pricingsService: PricingsService,
    private toastService: ToastService,
    private blackboxesService: BlackboxService,
    private customersService: CustomersService,
    private chargingStationsService: ChargingStationsService,
    injector: Injector,
    private spinner: NgxSpinnerService
  ) {
    super(injector);
    this.subscribeToUserAuthState();

    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        if (
          event["url"].startsWith("/auth/login") ||
          event["url"].startsWith("/auth/register") ||
          event["url"].startsWith("/auth/forgotpassword") ||
          event["url"].startsWith("/auth/used-token-feedback") ||
          event["url"].startsWith("/auth/resetpassword") ||
          event["url"].startsWith("/logout-callback") ||
          event["url"].startsWith("/forbidden") ||
          event["url"].startsWith("/public-charge-plans") ||
          event["url"].startsWith("/pc") ||
          event["url"].startsWith("/public-charge") ||
          event["url"].startsWith("/public-charge-canceled") ||
          event["url"].startsWith("/auth/emailconfirmation") ||
          event["url"].startsWith("/auth/emailChangeConfirmation") ||
          event["url"].startsWith("/auth/welcome") ||
          event["url"].startsWith("/auth/claim-autochargeId")
        ) {
          this.isVisible = false;
        } else {
          this.isVisible = true;
        }
      }
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.spinner.show();
    this.todayDate = new Date().toISOString().split("T")[0];
    this.authenticationService.currentUserLoaded$.subscribe((user) => {
      if (!user) return;
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
      this.pool = localStorage.getItem("pool-url");
      this.getRoles();
      this.checkPricings();
      this.subscribeToUserAuthState();
      this.isProduction =
        this.authenticationService.getLoggedInUser().email ==
        "technik@cubos.com";
      this.isRuhr =
        this.authenticationService.getLoggedInUser().email ==
        "schieweck@cubos.ruhr";
      this.isVfl =
        this.authenticationService.getLoggedInUser().email ==
        "vfl-wolfsburg@cubos.com";
      this.isStihl =
        this.authenticationService.getLoggedInUser().email ==
        "stihl@cubos.com";
      this.isFunke =
        this.authenticationService.getLoggedInUser().email ==
        "funke@cubos.com";        
      this.isNavCollapsed = localStorage.getItem("isNavCollapsed") == "true";
      this.isOffScreen = window.matchMedia(
        "screen and (max-width: 576px)"
      ).matches;
      this.isScanOpen = false;
      this.isScanPending = false;
      this.usersService.getLoggedInUser().subscribe(
        (result) => {
          this.getRoles();
          this.user = result;
        },
        (error) => {}
      );
    });
  }

  ngAfterViewInit() {
    this.whitelabel = localStorage.getItem("whitelabel");
    this.determineStage();
  }

  resetRoles() {
    this.isOperator = false;
    this.isCustomer = false;
    this.isUser = false;
    this.isSupporter = false;
    this.isTechnical = false;
    this.isAccount = false;
  }

  getRoles() {
    this.resetRoles();
    if (this.authenticationService.userHasRole("Operator")) {
      this.isOperator = true;
    }
    if (this.authenticationService.userHasRole("Customer")) {
      this.isCustomer = true;
    }
    if (this.authenticationService.userHasRole("User")) {
      this.isUser = true;
    }
    if (this.authenticationService.userHasRole("Supporter")) {
      this.isSupporter = true;
    }
    if (this.authenticationService.userHasRole("Technical")) {
      this.isTechnical = true;
    }
    if (this.authenticationService.userHasRole("Account")) {
      this.isAccount = true;
    }
    if (this.isOperator || this.isCustomer) {
      this.getBlackbox();
    }
  }

  getBlackbox() {
    const customerId = localStorage.getItem("customerId");
    if (!customerId) return;
    this.blackboxesService.getByCustomerId(parseInt(customerId)).subscribe(
      (result) => {
        if (result != null && result.length > 0) {
          this.isBlackboxAvailable = true;
        }
      },
      (error) => console.error(error)
    );
  }

  determineStage() {
    this.isStageTesting =
      window.location.host === "cubos-connect-testing.azurewebsites.net" ||
      window.location.host === "testing.mycubos.com";
    this.isStageDev =
      window.location.host === "cubos-connect-dev.azurewebsites.net" ||
      window.location.host === "dev.mycubos.com";
    this.isStageExperimental =
      window.location.host === "cubos-connect-experimental.azurewebsites.net";
    if (
      window.location.host == "localhost:44304" ||
      window.location.host == "localhost:5001"
    ) {
      this.isStageLocal = true;
    }
  }

  openVerticallyCentered(content) {
    this.modalService.open(content, { centered: true });
  }

  async checkPricings() {
    const ownerUserId = localStorage.getItem("userId");
    if (!ownerUserId) return false;
    if (this.isTechnical || this.isAccount) {
      this.isAllowedInvoices = false;
      return;
    }
    if (this.isOperator) {
      this.pricingsService.getPricingsOfUser(ownerUserId).subscribe(
        (pricings) => {
          if (!pricings) return;
          if (
            pricings.length > 0 &&
            plainToClass(PricingDto, pricings).find(
              (p) => p.productId == null && p.priceId == null
            )
          ) {
            this.isAllowedInvoices = true;
          } else {
            this.isAllowedInvoices = false;
          }
        },
        (error) => console.error(error)
      );
    } else {
      this.pricingsService.getPricingsOfCurrentUser(ownerUserId).subscribe(
        (pricings) => {
          if (!pricings) return;
          if (
            pricings.length > 0 &&
            plainToClass(PricingDto, pricings).find(
              (p) => p.productId == null && p.priceId == null
            )
          ) {
            this.isAllowedInvoices = true;
          } else {
            this.isAllowedInvoices = false;
          }
        },
        (error) => console.error(error)
      );
    }
  }

  subscribeToUserAuthState() {
    this.authenticationService.authChanged$.subscribe((result) => {
      super.ngOnInit();
      this.isUserAuthenticated = result;
    });
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    this.isOffScreen = this.screenWidth <= 576;
    if (this.screenWidth <= 880) {
      this.isOpen = false;
    }
  }

  toggleQrScanner() {
    if (this.isScanOpen) {
      this.closeQrScanner();
      return;
    }
    this.isScanOpen = true;
    if (this.qrActionInstance && !this.qrActionInstance.isStart) {
      this.qrActionInstance.start(
        (devices: Array<{ label: string; deviceId: string }>) => {
          const selected = this.selectEnvironmentCamera(devices);
          if (selected) this.qrActionInstance.playDevice(selected.deviceId);
        }
      );
    }
  }

  private selectEnvironmentCamera(
    devices: Array<{ label: string; deviceId: string }>
  ): { deviceId: string } | null {
    if (!devices?.length) return null;
    const env = devices.find((d) =>
      /back|rear|environment|rück|hinter/i.test(d.label || "")
    );
    return env ?? devices[0];
  }

  closeQrScanner() {
    if (this.qrActionInstance?.isStart) {
      this.qrActionInstance.stop();
    }
    this.isScanOpen = false;
  }

  private subscribeToQrScanner() {
    if (!this.qrActionInstance || this.isQrScannerSubscribed) {
      return;
    }
    this.isQrScannerSubscribed = true;
    if (this.qrActionInstance.data) {
      const dataStream = this.qrActionInstance.data as unknown as Observable<
        Array<{ value?: string }>
      >;
      dataStream.subscribe((results) => {
        const rawValue: string | undefined = results?.[0]?.value;
        if (!rawValue || this.isScanPending) {
          return;
        }
        this.isScanPending = true;
        const evseId = this.extractEvseIdFromScan(rawValue);
        if (!evseId) {
          this.toastService.error("Ungültiger QR-Code.");
          this.closeQrScanner();
          setTimeout(() => {
            this.isScanPending = false;
          }, 300);
          return;
        }
        this.chargingStationsService
          .getChargingStationPublicDetailsByEvseId(evseId)
          .subscribe(
            (result) => {
              if (result?.id) {
                this.closeQrScanner();
                this.chargingStationsService
                  .checkCanRemoteStart(result.id)
                  .subscribe(
                    (canRemoteStart) => {
                      if (canRemoteStart) {
                        this.router.navigate([
                          "/chargingstations/summary/edit",
                          result.id,
                        ]);
                      } else if (result.isPublicCharge) {
                        this.router.navigate(["/pc"], {
                          queryParams: { cs: result.id },
                        });
                      } else {
                        this.toastService.error(
                          "Sie sind für diese Station nicht freigeschaltet."
                        );
                      }
                      setTimeout(
                        () => {
                          this.isScanPending = false;
                        },
                        300
                      );
                    },
                    () => {
                      if (result.isPublicCharge) {
                        this.router.navigate(["/pc"], {
                          queryParams: { cs: result.id },
                        });
                      } else {
                        this.toastService.error(
                          "Sie sind für diese Station nicht freigeschaltet."
                        );
                      }
                      setTimeout(
                        () => {
                          this.isScanPending = false;
                        },
                        300
                      );
                    }
                  );
              } else {
                this.toastService.error("Ladestation nicht gefunden.");
                this.closeQrScanner();
                setTimeout(
                  () => {
                    this.isScanPending = false;
                  },
                  300
                );
              }
            },
            () => {
              this.toastService.error("Ladestation nicht gefunden.");
              this.closeQrScanner();
              setTimeout(() => {
                this.isScanPending = false;
              }, 300);
            }
          );
      });
    }
  }

  private extractEvseIdFromScan(rawValue: string): string | null {
    try {
      const url = new URL(rawValue);
      const evseId = url.searchParams.get("evseid");
      return this.normalizeEvseId(evseId);
    } catch {
      return this.normalizeEvseId(rawValue);
    }
  }

  private normalizeEvseId(evseId: string | null): string | null {
    if (!evseId) {
      return null;
    }
    const normalized = evseId.replace(/[\s*]/g, "").toUpperCase();
    const evseIdPattern = /^DECUB[A-Z0-9]{1,20}$/i;
    return evseIdPattern.test(normalized) ? normalized : null;
  }

  toggleNavbar() {
    this.isOpen = !this.isOpen;
  }

  isRoleCustomer(): boolean {
    return this.authenticationService.userHasRole(Roles.Customer);
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(["logout-callback"]);
  }

  collapse(onlyOnTouchDevice: boolean = false) {
    // collapse() always
    // collapse(true) only on mobile
    if (!onlyOnTouchDevice || (onlyOnTouchDevice && this.isOffScreen)) {
      this.isNavCollapsed = !this.isNavCollapsed;
      localStorage.setItem("isNavCollapsed", this.isNavCollapsed.toString());
      document.getElementById("app").classList.toggle("collapsed");
    }
  }

  isCustomerView(): boolean {
    return this.authenticationService.userHasRole("Customer");
  }

  isUserView(): boolean {
    return this.authenticationService.userHasRole("User");
  }

  // pricingToggle = this.showPricing()
  // async showPricing() {
  //   const client = new AppConfigurationClient(environment.featureToggleConnection);
  //   var val = await client.getConfigurationSetting({ key: ".appconfig.featureflag/ShowPricing"});
  //   return JSON.parse(val.value).enabled;
  // }

  // invoiceToggle = this.showInvoice()
  // async showInvoice() {
  //   const client = new AppConfigurationClient(environment.featureToggleConnection);
  //   var val = await client.getConfigurationSetting({ key: ".appconfig.featureflag/ShowInvoice" });
  //   return JSON.parse(val.value).enabled;
  // }
}
